import React, { Component } from 'react';
import { Table, Row, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data2_4, columnsData } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import compute from "./compute";
import TableText from "@/components/table/TableText";

const { MonthPicker, } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loadingSave: false,
            loading: true,
            print: false
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        data = compute(data);
        this.setState({
            data
        });

    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data2_4);
        let data = JSON.parse(dataBegin);
        fetch(`/_4_4_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_4', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_4_1', 1.5, '4.40', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    render() {
        const { data, date } = this.state;
        const width = document.body.offsetWidth - 2700 > 300 ? document.body.offsetWidth - 2700 : 300;
        const totalIndex = [10];
        const columns = [
            {
                title: 'City(Domestic)/ Country(oversea) Top 10',
                dataIndex: 'name',
                key: 'name',
                align: "center",
                fixed: "left",
                width,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: index == 10 ? 'text' : 'input',
                        name: "name",
                        onChange: this.onChange,
                        totalIndex
                    };
                    return <TableText data={props} />
                }
            },
            ...columnsData(date).map(item => {
                return {
                    title: item.title,
                    children: item.children.map(x => {
                        return {
                            title: x.title,
                            dataIndex: x.key,
                            key: x.key,
                            width: 150,
                            render: (text, record, index) => {
                                const props = {
                                    text,
                                    index,
                                    type: index == 10 && x.type == 'inputNumber' ? "number" : x.type,
                                    name: x.key,
                                    onChange: this.onChange,
                                    totalIndex
                                };
                                return <TableText data={props} />
                            }
                        }
                    })
                }
            }),
        ];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_4_1" style={{ width: this.state.print ? 3050 : 'auto' }}>
                        <Row>4.4 Geographic City(Domestic)/Country(oversea) Top 10</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <span
                                style={{
                                    color: "#666",
                                    fontSize: 12,
                                    marginLeft: 10
                                }}
                            >
                                数据月份
                            </span>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3000 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3000, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_4_4">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-4/index.js